export const GLOBAL__MUTATIONS = {
  SET_IS_LOADING: "SET_IS_LOADING",
  SET_COMMON_ERRORS: "SET_COMMON_ERRORS",
};

export const MODAL__MUTATIONS = {
  SET_IS_OPEN: "SET_IS_OPEN",
};

export const CRYPTO__MUTATIONS = {
  GETALL: "GETALL",
  DETAILS: "DETAILS",
  CREATE: "CREATE",
  NETWORKS: "NETWORKS",
  OVYPAY: "OVYPAY",
  DELETECRYPTO: "DELETECRYPTO",
  SENDOTP: "SENDOTP",
  CHANGESTEP: "CHANGESTEP",
  CODE: "CODE",
  OVYPAY_CLIENT_URL: "OVYPAY_CLIENT_URL",
};

export const BANK__MUTATIONS = {
  GETALL: "GETALL",
  DETAILS: "DETAILS",
  CREATE: "CREATE",
  DELETEBANK: "DELETEBANK",
};

export const LOGOUT__DIALOG__MUTATIONS = {
  SHOW_DIALOG: "SHOW_DIALOG",
  HIDE_DIALOG: "HIDE_DIALOG",
};

export const AUTHENTICATION__MUTATIONS = {
  LOGIN_EMAIL: "LOGIN_EMAIL",
  RESET_EMAIL: "RESET_EMAIL",
  RESET_CODE: "RESET_CODE",
  RESET_ATTEMPT: "RESET_ATTEMPT",
  RESET_NEWPASS: "RESET_NEWPASS",
  RESET_REPEATPASS: "RESET_REPEATPASS",
  SEND_EMAIL_TO: "SEND_EMAIL_TO",
  LOGIN_PASSWORD: "LOGIN_PASSWORD",
  TOKEN: "TOKEN",
  REMOVE_TOKEN: "REMOVE_TOKEN",
  CLIENT: "CLIENT",
  REGISTER_ACCOUNT_TYPE: "REGISTER_ACCOUNT_TYPE",
  REGISTER_FNAME: "REGISTER_FNAME",
  REGISTER_LNAME: "REGISTER_LNAME",
  REGISTER_EMAIL: "REGISTER_EMAIL",
  REGISTER_PASSWORD: "REGISTER_PASSWORD",
  REGISTER_CONFIRM_PASSWORD: "REGISTER_CONFIRM_PASSWORD",
  RESET_REGISTER_INFO: "RESET_REGISTER_INFO",
  RESET_LOGIN_INFO: "RESET_LOGIN_INFO",
  SOCIAL_LOGIN_EMAIL: "SOCIAL_LOGIN_EMAIL",
  API_LOGIN_FLAG: "API_LOGIN_FLAG",
  VIEW_PASSWORD: "VIEW_PASSWORD",
  CREATEDTIME: "CREATEDTIME",
  REGISTER_OTP: "REGISTER_OTP",
  USER_OTP: "USER_OTP",
  SENDREGISTEROTP: "SENDREGISTEROTP",
  FORGETPASSWORDCODE: "FORGETPASSWORDCODE",
  UPDATESTEPPER: "UPDATESTEPPER",
  CHANGESTEP: "CHANGESTEP",
  RESET_RECEIVED_OTP: "RESET_RECEIVED_OTP",
};

export const MAM__WALLET__MUTATIONS = {
  WALLETTRANSACTIONHISTORY: "WALLETTRANSACTIONHISTORY",
  USERMAMWALLETSUMMARY: "USERMAMWALLETSUMMARY",
  MAMWALLETINTERNALTRANSFERACCOUNT: "MAMWALLETINTERNALTRANSFERACCOUNT",
  INVESTORWALLETHISTORY: "INVESTORWALLETHISTORY",
  MANAGERWALLETHISTORY: "MANAGERWALLETHISTORY",
  WALLETINTERNALTRANSFERCODE: "WALLETINTERNALTRANSFERCODE",
  WALLETINTERNALTRANSFERDETAILS: "WALLETINTERNALTRANSFERDETAILS",
  MAMWALLETWITHDRAWDETAILS: "MAMWALLETWITHDRAWDETAILS",
  MAMWALLETWITHDRAWFINISH: "MAMWALLETWITHDRAWFINISH",
};

export const PROFILE__MUTATIONS = {
  PROFILE: "PROFILE",
  PROFILE_STATUS: "PROFILE_STATUS",
  UPDATEPROFILEINFO: "UPDATEPROFILEINFO",
  IDENTITYVERIFICATION: "IDENTITYVERIFICATION",
  RESIDENCEVERIFICATION: "RESIDENCEVERIFICATION",
  IDENTITYVERIFICATIONDOCUMENTS: "IDENTITYVERIFICATIONDOCUMENTS",
  RESIDENCEVERIFICATIONDOCUMENTS: "RESIDENCEVERIFICATIONDOCUMENTS",
  BECOMEANIB: "BECOMEANIB",
  ACCOUNTSUMMARY: "ACCOUNTSUMMARY",
  LIVETRADES: "LIVETRADES",
  TOTALLIVETRADES: "TOTALLIVETRADES",
  DELETEDOCUMENT: "DELETEDOCUMENT",
  PROFITLOSS:"PROFITLOSS",
  POPUPNOTICE:"POPUPNOTICE",

  //2f
  TWOFA_SETUP: "TWOFA_SETUP",
  TWOFA_CLEAR: "TWOFA_CLEAR",
};

export const BANK__INFORMATION__MUTATIONS = {
  BANK_INFORMATIONS: "BANK_INFORMATIONS",
  UPDATE_BANK_LISTS: "UPDATE_BANK_LISTS",
  BANK_NAME: "BANK_NAME",
  BANK_ACCOUNT_NUMBER: "BANK_ACCOUNT_NUMBER",
  BANK_COUNTRY: "BANK_COUNTRY",
  BANK_CITY: "BANK_CITY",
  BANK_STATE: "BANK_STATE",
  BANK_IBAN_NUMBER: "BANK_IBAN_NUMBER",
  BANK_POSTAL_CODE: "BANK_POSTAL_CODE",
  BANK_SWIFT_NUMBER: "BANK_SWIFT_NUMBER",
  BANK_ADDRESS: "BANK_ADDRESS",
  BANK_ACCOUNT_NAME: "BANK_ACCOUNT_NAME",
  RESET: "RESET",
};

export const AGREEMENT__MUTATIONS = {
  NOTACCEPTEDAGREEMENTS: "NOTACCEPTEDAGREEMENTS",
  AGREEMENTHISTORIES: "AGREEMENTHISTORIES",
  UPLOADAGREEMENTFILE: "UPLOADAGREEMENTFILE",
};

export const PANEL_SWITCHER_MUTATIONS = {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  SET_SSO_URL: 'SET_SSO_URL'
};

export const COUNTRIES__MUTATIONS = {
  COUNTRIES: "COUNTRIES",
};

export const CITIES__MUTATIONS = {
  CITIES: "CITIES",
};

export const STATES__MUTATIONS = {
  STATES: "STATES",
};

export const FAQS__MUTATIONS = {
  FAQS: "FAQS",
};

export const COMPANYINFO__MUTATIONS = {
  COMPANYINFO: "COMPANYINFO",
};

export const TICKETS__MUTATIONS = {
  SET_TICKETS: "SET_TICKETS",
  SET_TOTAL_TICKETS: "SET_TOTAL_TICKETS",
  SET_TICKET_DETAILS: "SET_TICKET_DETAILS",
  SET_NEW_REPLY: "SET_NEW_REPLY",
  SET_TICKET_SUBJECT: "SET_TICKET_SUBJECT",
  SET_TICKET_DESCRIPTION: "SET_TICKET_DESCRIPTION",
  RESET_TICKET: "RESET_TICKET",
  RESET_COMMENT: "RESET_COMMENT",
};

export const TRADING__MUTATIONS = {
  CLIENTLIVETRADES: "CLIENTLIVETRADES",
  TOTALLIVETRADES: "TOTALLIVETRADES",
  LEVERAGES: "LEVERAGES",
  LEVERAGEACCOUNTTYPE: "LEVERAGEACCOUNTTYPE",
  ACCOUNTTYPES: "ACCOUNTTYPES",
  LIVEACCOUNTS: "LIVEACCOUNTS",
  DEMOACCOUNTS: "DEMOACCOUNTS",
  MT5ACCOUNTDETAILS: "MT5ACCOUNTDETAILS",
  TRADEHISTORY: "TRADEHISTORY",
  ALLTRADEDETAILS: "ALLTRADEDETAILS",
  TOTALLIVEACCOUNTS: "TOTALLIVEACCOUNTS",
  DEMOACCOUNTTYPES: "DEMOACCOUNTTYPES",
  LIVETRADINGACCOUNTS: "LIVETRADINGACCOUNTS",
  INVESTORACCOUNTLIVETRADES: "INVESTORACCOUNTLIVETRADES",
  INVESTORACCOUNTTRADEHISTORY: "INVESTORACCOUNTTRADEHISTORY",
  MANAGERACCOUNTBALANCECARDDETAILS: "MANAGERACCOUNTBALANCECARDDETAILS",
  VIEWMANAGERDETAILS: "VIEWMANAGERDETAILS",
};

export const TRANSACTION__MUTATIONS = {
  TRANSACTIONHISTORY: "TRANSACTIONHISTORY",
  RECENTTRANSACTIONHISTORY: "RECENTTRANSACTIONHISTORY",
  TRADERTRANSACTIONS: "TRADERTRANSACTIONS",
  PAYMENTMETHOD: "PAYMENTMETHOD",
  ACCOUNTSTODEPOSIT: "ACCOUNTSTODEPOSIT",
  //deposit
  CASHDEPOSIT: "CASHDEPOSIT",
  BANKDEPOSIT: "BANKDEPOSIT",
  CARDDEPOSIT: "CARDDEPOSIT",
  //withdraw
  SENDCODE: "SENDCODE",
  CASHWITHDRAW: "CASHWITHDRAW",
  CARDWITHDRAW: "CARDWITHDRAW",
  BANKWITHDRAW: "BANKWITHDRAW",
  WITHDRAWDETAILS: "WITHDRAWDETAILS",
  INTERNALTRANSFERACCOUNT: "INTERNALTRANSFERACCOUNT",
  INTERNALTRANSFERCODE: "INTERNALTRANSFERCODE",
  INTERNALTRANSFERDETAILS: "INTERNALTRANSFERDETAILS",
};

export const MAM__MUTATIONS = {
  INVESTORMANAGERACCOUNT: "INVESTORMANAGERACCOUNT",
  MANAGERLISTS: "MANAGERLISTS",
  TRADINGACCOUNTINFO: "TRADINGACCOUNTINFO",
  ACCOUNTTYPESANDLEVERAGES: "ACCOUNTTYPESANDLEVERAGES",
  STUSERNAMES: "STUSERNAMES",
  MYMANAGERACCOUNTS: "MYMANAGERACCOUNTS",
  MYINVESTORACCOUNTS: "MYINVESTORACCOUNTS",
  LIVETRADESMANAGERINVESTOR: "LIVETRADESMANAGERINVESTOR",
  MANAGERACCOUNTDETAILS: "MANAGERACCOUNTDETAILS",
  LIVEORDERSMANAGERINVESTORS: "LIVEORDERSMANAGERINVESTORS",
  ORDERHISTORYMANAGERINVESTORS: "ORDERHISTORYMANAGERINVESTORS",
  MANAGERACTIVERUNNINGORDERDETAILS: "MANAGERACTIVERUNNINGORDERDETAILS",
};

export const PLATFORMS__MUTATIONS = {
  DOWNLOADPLATFORMS: "DOWNLOADPLATFORMS",
};

export const LEVERAGE__MUTATIONS = {
  USERLEVERAGE: "USERLEVERAGE",
  ALLLEVERAGES: "ALLLEVERAGES",
};

export const CHARTS__MUTATIONS = {
  PROFITLOSSCHARTHISTORY: "PROFITLOSSCHARTHISTORY",
  CLOSEDTRADESPROFITLOSSCHARTHISTORY: "CLOSEDTRADESPROFITLOSSCHARTHISTORY",
  DASHBOARDPROFITLOSSCHARTHISTORY: "DASHBOARDPROFITLOSSCHARTHISTORY",
  SINGLEACCOUNTPROFITLOSSSUMMARY: "SINGLEACCOUNTPROFITLOSSSUMMARY",
  MANAGERINVESTORPROFITLOSSCHART: "MANAGERINVESTORPROFITLOSSCHART",
  MANAGERINVESTORBUYSELLCHART: "MANAGERINVESTORBUYSELLCHART",
};

export const ACCOUNT__MUTATIONS = {
  ACCOUNTNO: "ACCOUNTNO",
};

export const NOTIFICATIONS__MUTATIONS = {
  NOTIFICATIONS: "NOTIFICATIONS",
  SET_POLLING_INTERVAL: "SET_POLLING_INTERVAL",
  STOP_POLLING_INTERVAL: "STOP_POLLING_INTERVAL"
};

export const DEPOSITMETHODS__MUTATIONS = {
  DEPOSITMETHODS: "DEPOSITMETHODS",
  DEPOSITACCOUNTS: "DEPOSITACCOUNTS",
  BROKERSBANK: "BROKERSBANK",
  GETPAYMENTSYSTEM: "GETPAYMENTSYSTEM",
  NEEDSLIP: "NEEDSLIP",
  INRRATE: "INRRATE",
  CREATECRYPTODEPOSITOVIPAYQR: "CREATECRYPTODEPOSITOVIPAYQR",
  CHECKCRYPTODEPOSITOVIPAY: "CHECKCRYPTODEPOSITOVIPAY",
  PAYMENTNOTIFICATION: "PAYMENTNOTIFICATION",
  PAYMENTLOG: "PAYMENTLOG",
};

export const WITHDRAWMETHODS__MUTATIONS = {
  WITHDRAWMETHODS: "WITHDRAWMETHODS",
  WITHDRAWACCOUNTS: "WITHDRAWACCOUNTS",
  BROKERSBANK: "BROKERSBANK",
  USERCRYPTOADDRESS: "USERCRYPTOADDRESS",
  INRRATE: "INRRATE",
  OTPVIA: "OTPVIA",
};

export const PUBLIC_LOGIN__MUTATIONS = {
  LOGINPAGEINFO: "LOGINPAGEINFO",
  TERMSANDCONDITIONLINK: "TERMSANDCONDITIONLINK",
  COUNTRIES: "COUNTRIES"
};

export const TRADABLEBONUS__MUTATIONS = {
  CREATETRADABLEBONUSACCOUNT: "CREATETRADABLEBONUSACCOUNT",
  TRADABLEBONUSACCOUNTINFO: "TRADABLEBONUSACCOUNTINFO",
};

export const NOMINEE__MUTATIONS = {
  SET_NOMINEES: "SET_NOMINEES",
  SET_SELECTED: "SET_SELECTED",
};
